// App Store Review Mode banner + skip-payment button.
//
// Shown on every checkout page (event tickets, tournament registration,
// shop cart, membership) only when the current user's email is in the
// backend REVIEW_MODE_EMAILS allow-list. Apple reviewers use it to
// validate every monetised flow without supplying real card / UPI data.
//
// The banner deliberately uses a distinctive yellow palette so it's
// impossible to mistake for normal UI — reviewers and developers should
// always be able to tell at a glance that they're on a bypass path.
export default function ReviewModeBanner({ onBypass, disabled, amountLabel }) {
  return (
    <div
      data-testid="review-mode-banner"
      className="bg-yellow-50 border-2 border-yellow-300 rounded-2xl p-4 mt-4"
    >
      <div className="flex items-start gap-3">
        <i className="ph-bold ph-shield-check text-2xl text-yellow-600 mt-0.5" />
        <div className="flex-1">
          <p className="font-extrabold text-yellow-800 text-sm">
            App Review Mode
          </p>
          <p className="text-xs text-yellow-700 mt-1 leading-snug">
            This reviewer account can complete the flow without making a
            real payment. The booking will be recorded with{' '}
            <code className="bg-yellow-100 px-1 rounded">payment_method=free</code>.
          </p>
        </div>
      </div>
      <button
        type="button"
        onClick={onBypass}
        disabled={disabled}
        data-testid="review-mode-bypass-button"
        className="w-full mt-3 py-3 rounded-xl bg-yellow-500 text-white font-extrabold text-sm disabled:opacity-60"
      >
        {disabled
          ? 'Processing…'
          : `Confirm ${amountLabel || ''} without payment (App Review)`}
      </button>
    </div>
  );
}
